// extracted by mini-css-extract-plugin
export default {"teamSlider":"teamSlider__YONLB","member":"member__2Epjs","memberSlide":"memberSlide__SFIwW","businessCard":"businessCard__352Z-"};